import { render, staticRenderFns } from "./TheModalFisioterapia.vue?vue&type=template&id=0747315a&scoped=true&"
import script from "./TheModalFisioterapia.vue?vue&type=script&lang=js&"
export * from "./TheModalFisioterapia.vue?vue&type=script&lang=js&"
import style0 from "./TheModalFisioterapia.vue?vue&type=style&index=0&id=0747315a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747315a",
  null
  
)

export default component.exports